export default "__VITE_ASSET__D1kzTNtp__"